/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paste_Text_Short_WarningInputs */

const en_mobile_paste_text_short_warning = /** @type {(inputs: Mobile_Paste_Text_Short_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This text is very short. Tap Create audio again to continue.`)
};

const es_mobile_paste_text_short_warning = /** @type {(inputs: Mobile_Paste_Text_Short_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este texto es muy corto. Toca Crear audio otra vez para continuar.`)
};

/**
* | output |
* | --- |
* | "This text is very short. Tap Create audio again to continue." |
*
* @param {Mobile_Paste_Text_Short_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text_short_warning = /** @type {((inputs?: Mobile_Paste_Text_Short_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_Text_Short_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text_short_warning(inputs)
	return en_mobile_paste_text_short_warning(inputs)
});